


































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { moji2Hankana } from "@/types";

//------------------------------------------
// インターフェース
//------------------------------------------
// 選択肢一覧情報（呼び出し元から受け取る必要がある情報）
export interface ColumnKey {
  type: number; //フィルタタイプ 0:文字列 1:文字列（リスト選択） 2:数字
  key: string;
  text: string;
  selectable: string[] | null;
}

// フィルタ用条件（呼び出し元へ渡す必要がある検索条件）
export interface FilterClause {
  id: number;
  word: string | null;
  menu: boolean;
  matchType: number;
  numIdx: number;
  colKey: ColumnKey;
}

@Component
export default class SelectFilter extends Vue {
  //------------------------------------------
  // プロパティ
  //------------------------------------------
  // フィルタ条件
  @Prop({ default: () => [] }) filterClauses!: FilterClause[];
  // フィルタ選択肢
  @Prop({ default: () => [] }) columnKeys!: ColumnKey[];

  private menu = false;

  private numsets = [
    { value: 0, text: "に等しい" },
    { value: 1, text: "に等しくない" },
    { value: 2, text: "より大きい" },
    { value: 3, text: "以上" },
    { value: 4, text: "より小さい" },
    { value: 5, text: "以下" }
  ];

  // フィルタタイプ
  static FILTER_TYPE_EDIT = 0; // 通常
  static FILTER_TYPE_LIST = 1; // 一覧選択方式
  static FILTER_TYPE_NUMBER = 2; // 一覧選択方式（編集可）
  static FILTER_TYPE_EDIT_LIST = 3; // 数値大小方式
  @Prop({ default: SelectFilter.FILTER_TYPE_EDIT }) pFilterTypeEdit!: number;
  @Prop({ default: SelectFilter.FILTER_TYPE_LIST }) pFilterTypeList!: number;
  @Prop({ default: SelectFilter.FILTER_TYPE_NUMBER })
  pFilterTypeNumber!: number;
  @Prop({ default: SelectFilter.FILTER_TYPE_EDIT_LIST })
  pFilterTypeEditList!: number;

  // データなし
  static NO_DATA = "データなし";

  // 一致方法
  static MATCH_TYPE_PREFIX = 1; // 前方一致
  static MATCH_TYPE_PARTIAL = 2; // 部分一致
  @Prop({ default: SelectFilter.MATCH_TYPE_PREFIX }) pMatchTypePrefix!: number;
  @Prop({ default: SelectFilter.MATCH_TYPE_PARTIAL })
  pMatchTypePartial!: number;

  // セッションストレージ保存キー
  @Prop({ default: "", required: false }) storageKeyClauses!: string;

  //------------------------------------------
  // チップの表示
  //------------------------------------------
  private chipLabel(clause: FilterClause) {
    const label = clause.word == null ? "" : clause.word;
    let note = "";
    if (clause.colKey.type === SelectFilter.FILTER_TYPE_NUMBER) {
      for (let i = 0; i < this.numsets.length; i++) {
        const set = this.numsets[i];
        if (set.value === clause.numIdx) {
          note = set.text;
          break;
        }
      }
    }
    return `${clause.colKey.text}：${label}${note}`;
  }

  //------------------------------------------
  // 検索対象カラム一覧選択イベント
  //------------------------------------------
  private onListClick(idx: number) {
    // 検索条件作成
    const ck = this.columnKeys[idx];
    let max = 0;
    if (this.filterClauses.length > 0) {
      const obj = this.filterClauses.reduce((a, b) => (a.id > b.id ? a : b));
      max = obj.id;
    }
    if (ck.type === SelectFilter.FILTER_TYPE_LIST && ck.selectable == null) {
      ck.selectable = [];
    }
    const clause: FilterClause = {
      id: max + 1,
      colKey: ck,
      word: null,
      matchType: SelectFilter.MATCH_TYPE_PREFIX,
      numIdx: 0,
      menu: false
    };
    this.filterClauses.push(clause);

    // 追加した情報を表示
    setTimeout(() => {
      clause.menu = true;
    }, 100);
  }

  //------------------------------------------
  // チップの削除ボタン押下イベント
  //------------------------------------------
  private closeChip(clause: FilterClause) {
    const idx = this.filterClauses.indexOf(clause);
    if (idx != -1) {
      this.filterClauses.splice(idx, 1);
    }
    this.saveStorage();
  }

  //------------------------------------------
  // 検索条件全体削除ボタン押下イベント
  //------------------------------------------
  public clearAll() {
    this.filterClauses.splice(0);
    this.removeStorage();
  }

  //------------------------------------------
  // 条件をクリアする（ストレージは消さない）
  //------------------------------------------
  public clearExceptStorage() {
    this.filterClauses.splice(0);
  }

  //------------------------------------------
  // 検索条件メニュー開閉イベント
  //------------------------------------------
  private onMenuToggle(opend: boolean) {
    // 開いたときは何もしない。
    if (opend) return;

    // 閉じたときに、検索条件が空の場合は、要素を削除する
    for (let idx = this.filterClauses.length - 1; 0 <= idx; idx--) {
      const clause = this.filterClauses[idx];
      if (this.hiddenMenu(clause)) {
        this.filterClauses.splice(idx, 1);
      }
    }
    this.saveStorage();
  }

  //------------------------------------------
  // 検索条件メニューの非表示判定
  //------------------------------------------
  private hiddenMenu(clause: FilterClause) {
    let hidden = false;
    switch (clause.colKey.type) {
      case SelectFilter.FILTER_TYPE_EDIT:
      case SelectFilter.FILTER_TYPE_LIST:
      case SelectFilter.FILTER_TYPE_EDIT_LIST:
      case SelectFilter.FILTER_TYPE_NUMBER:
        hidden = clause.word == null || clause.word == "";
        break;
    }
    return hidden;
  }

  //------------------------------------------
  // 検索カラム変更メソッド
  //------------------------------------------
  private onChangeCol(value: any, clause: FilterClause) {
    // 変更したカラム情報に
    const ck = this.columnKeys.find(obj => {
      return obj.key === value;
    });
    if (ck == null) {
      return;
    }
    //初期化
    clause.colKey = ck;
    clause.word = null;
    clause.matchType = SelectFilter.MATCH_TYPE_PREFIX;
    clause.numIdx = 0;
  }

  //------------------------------------------
  // 検索条件セッションストレージ削除メソッド
  //------------------------------------------
  private removeStorage() {
    if (this.storageKeyClauses === "") {
      return;
    }
    sessionStorage.removeItem(this.storageKeyClauses);
  }
  //------------------------------------------
  // 検索条件セッションストレージ保存メソッド
  //------------------------------------------
  private saveStorage() {
    if (this.storageKeyClauses === "") {
      return;
    }
    const clauses: FilterClause[] = [];
    this.filterClauses.forEach(elm => {
      if (elm.word == null || elm.word == "") {
        return;
      }
      clauses.push(elm);
    });
    if (clauses.length === 0) {
      this.removeStorage();
      return;
    }
    sessionStorage.setItem(this.storageKeyClauses, JSON.stringify(clauses));
  }
  //------------------------------------------
  // 検索条件セッションストレージ復帰メソッド
  //------------------------------------------
  public restoreStorage() {
    if (this.storageKeyClauses === "") {
      return;
    }
    const jsonStr = sessionStorage.getItem(this.storageKeyClauses);
    if (jsonStr == null || jsonStr == "") {
      return;
    }
    const clauses: FilterClause[] = JSON.parse(jsonStr);
    clauses.forEach(clause => {
      this.filterClauses.push(clause);
    });
  }

  //------------------------------------------
  // 検索条件にvalが該当するかチェック
  // clausesは同じカラムの条件のみであること
  //------------------------------------------
  public isMatch(key: string, val: object) {
    // 同じカラムの検索条件のみ抽出
    const clauses = this.filterClauses.filter(clause => {
      return clause.colKey.key == key && clause.word != "";
    });
    if (val == null || clauses.length == 0) {
      return true;
    }
    let bret = true;
    for (let i = 0; i < clauses.length; i++) {
      const clause = clauses[i];
      switch (clause.colKey.type) {
        case SelectFilter.FILTER_TYPE_EDIT:
        case SelectFilter.FILTER_TYPE_LIST:
        case SelectFilter.FILTER_TYPE_EDIT_LIST:
          bret = this.isMatchString(val, clause);
          break;
        case SelectFilter.FILTER_TYPE_NUMBER:
          bret = this.isMatchNumber(val, clause);
          break;
      }
      if (!bret) {
        break;
      }
    }
    return bret;
  }

  //------------------------------------------
  // 検索条件にvalが該当するかチェック（文字列用）
  //------------------------------------------
  private isMatchString(val: any, clause: FilterClause) {
    if (clause.word == null) {
      return true;
    }
    //データなしの場合は、完全一致で判定
    if (clause.word === SelectFilter.NO_DATA) {
      return val === "" || val === SelectFilter.NO_DATA;
    }
    //文字列（リスト選択）の場合は完全一致
    if (clause.colKey.type === this.pFilterTypeList) {
      return val == clause.word;
    }
    const v = moji2Hankana(`${val}`);
    const w = moji2Hankana(clause.word);
    const idx = v
      .trim()
      .replaceAll("  ", " ")
      .toLowerCase()
      .indexOf(
        w
          .trim()
          .replaceAll("  ", " ")
          .toLowerCase()
      );
    // console.log("idx", idx, v, w)
    if (clause.matchType == SelectFilter.MATCH_TYPE_PREFIX) {
      // 前方一致
      return idx === 0;
    } else {
      // 部分一位
      return idx !== -1;
    }
  }

  //------------------------------------------
  // 検索条件にvalが該当するかチェック（数値用）
  //------------------------------------------
  private isMatchNumber(val: any, clause: FilterClause) {
    if (clause.word == null) {
      return true;
    }
    const v = Number(val);
    const w = Number(clause.word);
    // 数字に変換できない場合
    if (isNaN(v) || isNaN(w)) {
      return true;
    }
    switch (clause.numIdx) {
      case 0: //{ value: 0, text: "に等しい" }
        return v == w;
      case 1: //{ value: 1, text: "に等しくない" }
        return v != w;
      case 2: //{ value: 2, text: "より大きい" }
        return v > w;
      case 3: //{ value: 3, text: "以上" }
        return v > w || v == w;
      case 4: //{ value: 4, text: "より小さい" }
        return v < w;
      case 5: //{ value: 5, text: "以下" }
        return v < w || v == w;
    }
    return true;
  }
}
